import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export default function useResizeOverflowSlider(elRef) {

    const [parentElementParameters, setParentElementParameters] = useState({});

    const observer = useRef(
        new ResizeObserver(entries => {
            const { clientWidth, scrollWidth } = entries[0].target;
            setParentElementParameters({ clientWidth, scrollWidth });
        })
    );

    useEffect(() => {
        if (elRef.current) {
            observer.current.observe(elRef.current);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
        return () => observer.current.disconnect();

    }, [elRef, observer]);

    return parentElementParameters;
}
